
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"37","height":"25","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M11.344 9.418h-3.36V18H6.612V9.418H3.265V8.2h8.079v1.218zm5.974 8.694c-.989 0-1.88-.215-2.674-.644a4.915 4.915 0 01-1.876-1.806c-.448-.765-.672-1.62-.672-2.562 0-.943.224-1.797.672-2.562a4.812 4.812 0 011.876-1.792c.794-.439 1.685-.658 2.674-.658.98 0 1.867.22 2.66.658a4.712 4.712 0 011.862 1.792c.448.756.672 1.61.672 2.562 0 .952-.224 1.81-.672 2.576a4.843 4.843 0 01-1.862 1.792c-.793.43-1.68.644-2.66.644zm0-1.246c.719 0 1.363-.163 1.932-.49a3.545 3.545 0 001.358-1.344 3.777 3.777 0 00.504-1.932c0-.71-.168-1.349-.504-1.918a3.516 3.516 0 00-1.358-1.358c-.569-.327-1.213-.49-1.932-.49-.718 0-1.372.163-1.96.49a3.617 3.617 0 00-1.372 1.358 3.785 3.785 0 00-.49 1.918c0 .71.164 1.353.49 1.932.336.57.794 1.017 1.372 1.344.588.327 1.242.49 1.96.49zm15.9-8.666V18h-1.373V9.418h-5.683V18h-1.386V8.2h8.442z","fill":"#EB5757"}}),_c('rect',{attrs:{"x":".5","y":".5","width":"36","height":"24","rx":"1.5","stroke":"#EB5757"}})])
          )
        }
      }
    